import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_DIET_OR_DIET_CATEGORY_NODE,
  EXPAND_DIET_AND_DIET_CATEGORY_MAIN_TREE_KEYS,
  EXPAND_DIET_AND_DIET_CATEGORY_SUPPORTING_TREE_KEYS,
  FETCH_DIETS_AND_DIET_CATEGORIES,
  MOVE_DIETS,
  RENAME_DIET_OR_DIET_CATEGORY_NODE,
  REPLACE_DIET,
  RESET_DIETS_AND_DIET_CATEGORIES_TREE,
  SET_DATA_FOR_RENAMING_DIET_OR_DIET_CATEGORY_NODE,
} from '../action-types'

export const cleanupFetchDietsAndDietCategories = createAction(
  FETCH_DIETS_AND_DIET_CATEGORIES.CLEANUP,
)

export const addDietOrDietCategoryNode = createPayloadAction(
  ADD_DIET_OR_DIET_CATEGORY_NODE,
)

export const renameDietOrDietCategoryNode = createPayloadAction(
  RENAME_DIET_OR_DIET_CATEGORY_NODE,
)

export const resetDietsAndDietCategoriesTree = createAction(
  RESET_DIETS_AND_DIET_CATEGORIES_TREE,
)

export const setDataForRenamingDietOrDietCategory = createPayloadAction(
  SET_DATA_FOR_RENAMING_DIET_OR_DIET_CATEGORY_NODE,
)

export const moveDiets = createPayloadAction(MOVE_DIETS)
export const replaceDiet = createPayloadAction(REPLACE_DIET)

export const expandDietAndDietCategoryMainTreeKeys = createPayloadAction(
  EXPAND_DIET_AND_DIET_CATEGORY_MAIN_TREE_KEYS,
)

export const expandDietAndDietCategorySupportingTreeKeys = createPayloadAction(
  EXPAND_DIET_AND_DIET_CATEGORY_SUPPORTING_TREE_KEYS,
)
